const initialState = {
  data:{},
  search:'',
  filter:[],
  sort:{
    field:'bsns_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_BSNSS':
      return {
        ...state,
        data:  action.payload
      }
    case 'SORT_BSNSS':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_BSNSS':
      return {
        ...state,
        search: action.search
      }
    case 'EDIT_BSNS':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.bsns_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/bsnss.js